import jQuery from "jquery";
window.$ = window.jQuery = jQuery;
import mmenu from 'mmenu-js';



document.addEventListener(
    "DOMContentLoaded", () => {
        if (document.querySelector('#my-menu')) {

            /* mobile */
            new Mmenu( "#my-menu", {               
                /* searchfield : {
                    placeholder   : "Bitte Suchbegriff eingeben..."
                }, */
                "navbars": [
                    {
                       "position": "top",
                       "content": [
                          "<a class='menulogo' href='/'></a>",
                          /* "searchfield", */
                          "close"
                        ]
                    }
                 ],
                "extensions": [
                    /* "fullscreen",
                    "popup" */
                   "position-front",
                   "position-right"
                ],
                "setSelected": {
                    "parent": true
                 }           
            }
            );


            /* desktop */
            new Mmenu( "#my-menu-desktop", {
                columns: {
                    add:true,
                    visible: {                      
                        max:1,
                        min:1
                    }
                },
                /* searchfield : {
                    placeholder   : "Bitte Suchbegriff eingeben..."
                }, */
                "navbars": [
                    {
                       "position": "top",
                       "content": [
                          "<a class='menulogo' href='/'></a>",
                          /* "searchfield", */
                          "close"
                        ]
                    }
                 ],
                "extensions": [
                    /* "fullscreen",
                    "popup" */
                    "position-front",
                    "position-right"
                ],
                "setSelected": {
                    "parent": true
                }
                }                
                );

        }        

        mmenuSwitcher();

    }
);


function mmenuSwitcher() {
  if($(this).width() < 1400) {
    $('div.mainmenu > a.item.mm-menubtn').attr('href', '#my-menu');
  }
  else {
    $('div.mainmenu > a.item.mm-menubtn').attr('href', '#my-menu-desktop');
  }
}

$(window).on('resize', mmenuSwitcher);








